// (() => {
//   "use strict";

//   if (window.LGNDBonusCartGift) return;

//   const CONFIG_SELECTOR = "[data-lgnd-bonus-cart-gift-config]";
//   const ROW_SELECTOR = "[data-lgnd-bonus-cart-gift-row]";
//   const DISCOUNT_BADGE_SELECTOR = "[data-lgnd-cart-discount-code]";
//   const STORED_CODE_KEY = "lgnd:auto-bonus-cart-gift-code";
//   const FAILURE_KEY = "lgnd:auto-bonus-cart-gift-failure";
//   const REFRESH_KEY = "lgnd:auto-bonus-cart-gift-refresh";
//   const FAILURE_COOLDOWN_MS = 60 * 1000;
//   const CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/;

//   const routeRoot =
//     window.Shopify && window.Shopify.routes && window.Shopify.routes.root
//       ? window.Shopify.routes.root
//       : "/";
//   const cartBaseRoute = `${routeRoot.replace(/\/?$/, "/")}cart`;
//   const originalFetch = window.fetch.bind(window);

//   const state = {
//     syncing: false,
//     syncTimer: 0,
//     boundaryTimer: 0,
//     presentationTimer: 0,
//     lastRefreshSignature: "",
//     lastRefreshAt: 0
//   };

//   function normalizeCode(value) {
//     return String(value || "").trim().toLowerCase();
//   }

//   function getRequestUrl(request) {
//     if (typeof request === "string") return request;
//     if (request && typeof request.url === "string") return request.url;
//     return "";
//   }

//   function readStorage(storage, key) {
//     try {
//       return storage.getItem(key) || "";
//     } catch (error) {
//       return "";
//     }
//   }

//   function writeStorage(storage, key, value) {
//     try {
//       if (value) {
//         storage.setItem(key, value);
//       } else {
//         storage.removeItem(key);
//       }
//     } catch (error) {
//       // Storage can be unavailable in private browsing. The cart still works.
//     }
//   }

//   function getStoredAutomaticCode(cart) {
//     const storedValue = readStorage(window.localStorage, STORED_CODE_KEY);
//     if (!storedValue) return "";

//     try {
//       const storedState = JSON.parse(storedValue);

//       if (
//         storedState &&
//         storedState.code &&
//         storedState.cartToken &&
//         cart &&
//         cart.token &&
//         storedState.cartToken !== cart.token
//       ) {
//         return "";
//       }

//       return storedState && storedState.code ? storedState.code : "";
//     } catch (error) {
//       // Accept the plain-string format used by the first release.
//       return storedValue;
//     }
//   }

//   function setStoredAutomaticCode(code, cart) {
//     if (!code) {
//       writeStorage(window.localStorage, STORED_CODE_KEY, "");
//       return;
//     }

//     if (cart && cart.token) {
//       writeStorage(
//         window.localStorage,
//         STORED_CODE_KEY,
//         JSON.stringify({ code, cartToken: cart.token })
//       );
//     } else {
//       writeStorage(window.localStorage, STORED_CODE_KEY, code);
//     }
//   }

//   function parseShopifyDate(value) {
//     let dateValue = String(value || "").trim();
//     if (!dateValue) return null;

//     const hasTimeZone = /(?:z|[+-]\d{2}:?\d{2})$/i.test(dateValue);
//     const isIsoDateTime = /^\d{4}-\d{2}-\d{2}t\d{2}:\d{2}/i.test(dateValue);

//     if (isIsoDateTime && !hasTimeZone) {
//       dateValue += "Z";
//     }

//     const timestamp = Date.parse(dateValue);
//     return Number.isFinite(timestamp) ? timestamp : null;
//   }

//   function readConfiguration() {
//     const campaigns = [];
//     const appliedDiscountCodes = [];
//     const campaignKeys = new Set();
//     const appliedCodeKeys = new Set();
//     const configurationElements = document.querySelectorAll(CONFIG_SELECTOR);

//     configurationElements.forEach((element) => {
//       try {
//         const configuration = JSON.parse(element.textContent || "{}");

//         if (Array.isArray(configuration.campaigns)) {
//           configuration.campaigns.forEach((campaign) => {
//             const code = String(campaign && campaign.code ? campaign.code : "").trim();
//             const startsAt = parseShopifyDate(campaign && campaign.startsAt);
//             const endsAt = parseShopifyDate(campaign && campaign.endsAt);
//             const campaignKey = `${normalizeCode(code)}|${startsAt}|${endsAt}`;

//             if (
//               !code ||
//               startsAt === null ||
//               endsAt === null ||
//               endsAt < startsAt ||
//               campaignKeys.has(campaignKey)
//             ) {
//               return;
//             }

//             campaignKeys.add(campaignKey);
//             campaigns.push({
//               ...campaign,
//               code,
//               startsAt,
//               endsAt,
//               autoApply: campaign.autoApply === true
//             });
//           });
//         }

//         if (Array.isArray(configuration.appliedDiscountCodes)) {
//           configuration.appliedDiscountCodes.forEach((code) => {
//             const normalizedCode = normalizeCode(code);
//             if (!normalizedCode || appliedCodeKeys.has(normalizedCode)) return;

//             appliedCodeKeys.add(normalizedCode);
//             appliedDiscountCodes.push(String(code).trim());
//           });
//         }
//       } catch (error) {
//         console.warn("[Bonus Cart Gift] Invalid Liquid configuration.");
//       }
//     });

//     return {
//       campaigns,
//       appliedDiscountCodes,
//       isPresent: configurationElements.length > 0
//     };
//   }

//   function getActiveCampaign(campaigns, now = Date.now()) {
//     return campaigns
//       .filter((campaign) => {
//         return (
//           campaign.autoApply &&
//           campaign.startsAt <= now &&
//           now <= campaign.endsAt
//         );
//       })
//       .sort((left, right) => right.startsAt - left.startsAt)[0] || null;
//   }

//   function scheduleDateBoundary(campaigns) {
//     window.clearTimeout(state.boundaryTimer);

//     const now = Date.now();
//     const futureBoundaries = [];

//     campaigns.forEach((campaign) => {
//       if (!campaign.autoApply) return;
//       if (campaign.startsAt > now) futureBoundaries.push(campaign.startsAt);
//       if (campaign.endsAt >= now) futureBoundaries.push(campaign.endsAt + 1000);
//     });

//     if (!futureBoundaries.length) return;

//     const nextBoundary = Math.min(...futureBoundaries);
//     const maximumTimeout = 2147483000;
//     const delay = Math.min(Math.max(nextBoundary - now, 250), maximumTimeout);

//     state.boundaryTimer = window.setTimeout(() => {
//       scheduleSync(0);
//     }, delay);
//   }

//   async function getCart() {
//     const response = await originalFetch(`${cartBaseRoute}.js`, {
//       method: "GET",
//       headers: { Accept: "application/json" }
//     });

//     if (!response.ok) {
//       throw new Error("Unable to retrieve the cart.");
//     }

//     return response.json();
//   }

//   function isMarketingFreeGift(item) {
//     const properties = item && item.properties ? item.properties : {};
//     return String(properties._free_gift || "").toLowerCase() === "true";
//   }

//   function hasRealProduct(cart) {
//     return Array.isArray(cart.items) && cart.items.some((item) => {
//       return Number(item.quantity || 0) > 0 && !isMarketingFreeGift(item);
//     });
//   }

//   function addCode(codeMap, code) {
//     const displayCode = String(code || "").trim();
//     const normalizedCode = normalizeCode(displayCode);
//     if (!normalizedCode || codeMap.has(normalizedCode)) return;

//     codeMap.set(normalizedCode, displayCode);
//   }

//   function addDiscountApplication(codeMap, application) {
//     if (!application) return;

//     const applicationType = String(application.type || "").toLowerCase();
//     if (applicationType !== "discount_code") return;

//     addCode(codeMap, application.code || application.title);
//   }

//   function collectCartApplicationCodes(cart, codeMap) {
//     [cart.discount_applications, cart.cart_level_discount_applications]
//       .filter(Array.isArray)
//       .forEach((applications) => {
//         applications.forEach((application) => {
//           addDiscountApplication(codeMap, application);
//         });
//       });

//     if (!Array.isArray(cart.items)) return;

//     cart.items.forEach((item) => {
//       const allocations = Array.isArray(item.line_level_discount_allocations)
//         ? item.line_level_discount_allocations
//         : item.discount_allocations;

//       if (!Array.isArray(allocations)) return;

//       allocations.forEach((allocation) => {
//         addDiscountApplication(codeMap, allocation.discount_application);
//       });
//     });
//   }

//   function getAppliedCodes(cart, fallbackCodes = []) {
//     const codeMap = new Map();
//     const hasExplicitDiscountCodes = Array.isArray(cart.discount_codes);

//     if (hasExplicitDiscountCodes) {
//       cart.discount_codes.forEach((discount) => {
//         if (!discount || discount.applicable === false) return;
//         addCode(codeMap, discount.code || discount.title);
//       });
//     }

//     collectCartApplicationCodes(cart, codeMap);

//     if (!hasExplicitDiscountCodes && codeMap.size === 0) {
//       fallbackCodes.forEach((code) => addCode(codeMap, code));
//     }

//     return Array.from(codeMap.values());
//   }

//   function isCodeApplied(cart, code) {
//     const normalizedTarget = normalizeCode(code);
//     if (!normalizedTarget) return false;

//     if (Array.isArray(cart.discount_codes)) {
//       const explicitMatch = cart.discount_codes.find((discount) => {
//         return normalizeCode(discount && (discount.code || discount.title)) === normalizedTarget;
//       });

//       if (explicitMatch) return explicitMatch.applicable !== false;
//     }

//     return getAppliedCodes(cart).some((appliedCode) => {
//       return normalizeCode(appliedCode) === normalizedTarget;
//     });
//   }

//   function withoutCode(codes, codeToRemove) {
//     const normalizedRemoval = normalizeCode(codeToRemove);
//     return codes.filter((code) => normalizeCode(code) !== normalizedRemoval);
//   }

//   function withCode(codes, codeToAdd) {
//     const result = withoutCode(codes, codeToAdd);
//     result.push(codeToAdd);
//     return result;
//   }

//   function codeSetsMatch(leftCodes, rightCodes) {
//     const normalizeSet = (codes) => {
//       return Array.from(new Set(codes.map(normalizeCode).filter(Boolean))).sort().join("|");
//     };

//     return normalizeSet(leftCodes) === normalizeSet(rightCodes);
//   }

//   async function updateDiscountCodes(codes) {
//     const response = await originalFetch(`${cartBaseRoute}/update.js`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json"
//       },
//       body: JSON.stringify({ discount: codes.join(",") })
//     });

//     let cart = null;

//     try {
//       cart = await response.json();
//     } catch (error) {
//       // The HTTP status below still provides a useful failure message.
//     }

//     if (!response.ok || !cart) {
//       throw new Error("Shopify did not accept the discount update.");
//     }

//     return cart;
//   }

//   function getCartSignature(cart) {
//     if (!Array.isArray(cart.items)) return "empty";

//     return cart.items
//       .map((item) => {
//         return [item.key || item.variant_id, item.quantity, item.final_line_price].join(":");
//       })
//       .sort()
//       .join("|");
//   }

//   function getFailureSignature(campaign, cart, desiredCodes) {
//     return [
//       normalizeCode(campaign.code),
//       getCartSignature(cart),
//       desiredCodes.map(normalizeCode).sort().join(",")
//     ].join("::");
//   }

//   function readFailure() {
//     const serializedFailure = readStorage(window.sessionStorage, FAILURE_KEY);
//     if (!serializedFailure) return null;

//     try {
//       const failure = JSON.parse(serializedFailure);
//       return failure && failure.signature && Number(failure.until) ? failure : null;
//     } catch (error) {
//       return null;
//     }
//   }

//   function failureIsCoolingDown(signature) {
//     const failure = readFailure();
//     return Boolean(
//       failure &&
//       failure.signature === signature &&
//       Number(failure.until) > Date.now()
//     );
//   }

//   function storeFailure(signature) {
//     const until = Date.now() + FAILURE_COOLDOWN_MS;
//     writeStorage(
//       window.sessionStorage,
//       FAILURE_KEY,
//       JSON.stringify({ signature, until })
//     );
//   }

//   function clearFailure() {
//     writeStorage(window.sessionStorage, FAILURE_KEY, "");
//   }

//   function hasRenderedRow() {
//     return Boolean(document.querySelector(ROW_SELECTOR));
//   }

//   function refreshCartDisplay(signature) {
//     const now = Date.now();
//     let previousRefresh = null;

//     try {
//       previousRefresh = JSON.parse(readStorage(window.sessionStorage, REFRESH_KEY));
//     } catch (error) {
//       previousRefresh = null;
//     }

//     if (
//       (state.lastRefreshSignature === signature && now - state.lastRefreshAt < 5000) ||
//       (previousRefresh &&
//         previousRefresh.signature === signature &&
//         now - Number(previousRefresh.at) < 10000)
//     ) {
//       return;
//     }

//     state.lastRefreshSignature = signature;
//     state.lastRefreshAt = now;
//     writeStorage(
//       window.sessionStorage,
//       REFRESH_KEY,
//       JSON.stringify({ signature, at: now })
//     );

//     document.dispatchEvent(
//       new CustomEvent("cart:refresh", {
//         bubbles: true,
//         detail: { source: "bonus-cart-gift" }
//       })
//     );

//     document.dispatchEvent(
//       new CustomEvent("cart:updated", {
//         bubbles: true,
//         detail: { source: "bonus-cart-gift" }
//       })
//     );

//     if (window.location.pathname.replace(/\/$/, "") === `${routeRoot.replace(/\/$/, "")}cart`) {
//       window.location.reload();
//     }
//   }

//   function cleanPresentation() {
//     const verifiedCodes = new Set();

//     document.querySelectorAll(ROW_SELECTOR).forEach((row) => {
//       const code = normalizeCode(row.dataset.lgndBonusCartGiftCode);
//       if (code) verifiedCodes.add(code);
//     });

//     document.querySelectorAll(DISCOUNT_BADGE_SELECTOR).forEach((badge) => {
//       const code = normalizeCode(badge.dataset.lgndCartDiscountCode);
//       const shouldHide = code && verifiedCodes.has(code);

//       if (shouldHide) {
//         badge.hidden = true;
//         badge.setAttribute("aria-hidden", "true");
//         badge.dataset.lgndHiddenByBonusGift = "true";
//       } else if (badge.dataset.lgndHiddenByBonusGift === "true") {
//         badge.hidden = false;
//         badge.removeAttribute("aria-hidden");
//         delete badge.dataset.lgndHiddenByBonusGift;
//       }
//     });
//   }

//   function schedulePresentationCleanup() {
//     window.clearTimeout(state.presentationTimer);
//     state.presentationTimer = window.setTimeout(cleanPresentation, 50);
//   }

//   async function syncBonusCartGift() {
//     if (state.syncing) return;

//     const configuration = readConfiguration();
//     scheduleDateBoundary(configuration.campaigns);
//     cleanPresentation();

//     if (!configuration.isPresent) return;

//     state.syncing = true;

//     try {
//       const cart = await getCart();
//       const campaign = getActiveCampaign(configuration.campaigns);
//       const currentCodes = getAppliedCodes(cart, configuration.appliedDiscountCodes);
//       const storedAutomaticCode = getStoredAutomaticCode(cart);
//       const customerQualifies = Boolean(campaign && hasRealProduct(cart));

//       if (!customerQualifies) {
//         if (
//           storedAutomaticCode &&
//           currentCodes.some((code) => normalizeCode(code) === normalizeCode(storedAutomaticCode))
//         ) {
//           const desiredCodes = withoutCode(currentCodes, storedAutomaticCode);
//           await updateDiscountCodes(desiredCodes);
//           setStoredAutomaticCode("");
//           clearFailure();
//           refreshCartDisplay(`removed:${normalizeCode(storedAutomaticCode)}`);
//         } else {
//           setStoredAutomaticCode("");

//           if (hasRenderedRow()) {
//             refreshCartDisplay("remove-stale-bonus-row");
//           }
//         }

//         return;
//       }

//       if (isCodeApplied(cart, campaign.code)) {
//         setStoredAutomaticCode(campaign.code, cart);
//         clearFailure();

//         if (!hasRenderedRow()) {
//           refreshCartDisplay(`render:${normalizeCode(campaign.code)}`);
//         }

//         return;
//       }

//       let desiredCodes = currentCodes;

//       if (
//         storedAutomaticCode &&
//         normalizeCode(storedAutomaticCode) !== normalizeCode(campaign.code)
//       ) {
//         desiredCodes = withoutCode(desiredCodes, storedAutomaticCode);
//       }

//       desiredCodes = withCode(desiredCodes, campaign.code);
//       const failureSignature = getFailureSignature(campaign, cart, desiredCodes);

//       if (failureIsCoolingDown(failureSignature)) return;

//       const updatedCart = await updateDiscountCodes(desiredCodes);
//       const updatedCodes = getAppliedCodes(updatedCart);
//       const campaignApplied = isCodeApplied(updatedCart, campaign.code);
//       const discountStateChanged = !codeSetsMatch(currentCodes, updatedCodes);

//       if (campaignApplied) {
//         setStoredAutomaticCode(campaign.code, updatedCart);
//         clearFailure();
//         refreshCartDisplay(`applied:${normalizeCode(campaign.code)}`);
//       } else {
//         setStoredAutomaticCode("");
//         storeFailure(failureSignature);

//         if (discountStateChanged || hasRenderedRow()) {
//           refreshCartDisplay(`rejected:${normalizeCode(campaign.code)}`);
//         }

//         console.warn(
//           `[Bonus Cart Gift] ${campaign.code} was not applicable, so no cart gift was shown.`
//         );
//       }
//     } catch (error) {
//       console.warn("[Bonus Cart Gift]", error.message);
//     } finally {
//       state.syncing = false;
//       schedulePresentationCleanup();
//     }
//   }

//   function scheduleSync(delay = 200) {
//     window.clearTimeout(state.syncTimer);
//     state.syncTimer = window.setTimeout(syncBonusCartGift, delay);
//   }

//   window.fetch = async (...args) => {
//     const response = await originalFetch(...args);
//     const requestUrl = getRequestUrl(args[0]);

//     if (!state.syncing && response.ok && CART_MUTATION_PATTERN.test(requestUrl)) {
//       scheduleSync();
//     }

//     return response;
//   };

//   document.addEventListener("cart:refresh", schedulePresentationCleanup);
//   document.addEventListener("cart:updated", () => scheduleSync());

//   const observer = new MutationObserver(schedulePresentationCleanup);

//   function initialize() {
//     observer.observe(document.documentElement, { childList: true, subtree: true });
//     cleanPresentation();
//     scheduleSync(0);
//   }

//   window.LGNDBonusCartGift = {
//     refresh: () => scheduleSync(0)
//   };

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", initialize, { once: true });
//   } else {
//     initialize();
//   }
// })();


































(() => {
  "use strict";

  if (window.LGNDBonusCartGift) return;

  const CONFIG_SELECTOR = "[data-lgnd-bonus-cart-gift-config]";
  const ROW_SELECTOR = "[data-lgnd-bonus-cart-gift-row]";
  const DISCOUNT_BADGE_SELECTOR = "[data-lgnd-cart-discount-code]";
  const DEBUG_PANEL_ID = "lgnd-bonus-cart-gift-debug";
  const DEBUG_STYLE_ID = "lgnd-bonus-cart-gift-debug-styles";
  const STORED_CODES_KEY = "lgnd:auto-bonus-cart-gift-code";
  const FAILURE_KEY = "lgnd:auto-bonus-cart-gift-failures";
  const REFRESH_KEY = "lgnd:auto-bonus-cart-gift-refresh";
  const FAILURE_COOLDOWN_MS = 60 * 1000;
  const REJECTION_VERIFICATION_DELAY_MS = 250;
  const CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/;

  const routeRoot =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : "/";
  const cartBaseRoute = `${routeRoot.replace(/\/?$/, "/")}cart`;
  const originalFetch = window.fetch.bind(window);
  let debugEnabled = /(?:^|[?&])bonus_debug=1(?:&|$)/.test(
    String((window.location && window.location.search) || "")
  );

  const state = {
    syncing: false,
    syncQueued: false,
    syncTimer: 0,
    failureTimer: 0,
    mutationRevision: 0,
    boundaryTimer: 0,
    presentationTimer: 0,
    lastRefreshSignature: "",
    lastRefreshAt: 0,
    debugReport: null
  };

  function normalizeCode(value) {
    return String(value || "").trim().toLowerCase();
  }

  function normalizeProductId(value) {
    const normalized = String(value || "").trim();
    return normalized && normalized !== "0" ? normalized : "";
  }

  function normalizeCampaignType(value) {
    const normalized = String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ");

    // Existing campaigns created before V2 remain Store Wide by default.
    if (!normalized || normalized === "store wide") return "store_wide";
    if (normalized === "product specific") return "product_specific";
    return "";
  }

  function uniqueValues(values, normalizer) {
    const results = [];
    const keys = new Set();

    values.forEach((value) => {
      const normalized = normalizer(value);
      if (!normalized || keys.has(normalized)) return;

      keys.add(normalized);
      results.push(String(value).trim());
    });

    return results;
  }

  function formatDebugDate(timestamp) {
    if (!Number.isFinite(Number(timestamp))) return "Invalid date";

    try {
      return new Date(Number(timestamp)).toISOString();
    } catch (error) {
      return "Invalid date";
    }
  }

  function getItemExclusionReason(item) {
    if (!item || Number(item.quantity || 0) <= 0) return "zero quantity";
    if (item.parent_relationship || item.parent_id) return "nested bundle component";
    if (isMarketingFreeGift(item)) return "_free_gift line";
    if (isRouteProtection(item)) return "Route protection";
    if (!normalizeProductId(item.product_id)) return "missing product_id";
    return "";
  }

  function getRawDiscountCodeStatus(cart) {
    if (!cart || !Array.isArray(cart.discount_codes)) return [];

    return cart.discount_codes.map((discount) => ({
      code: String((discount && (discount.code || discount.title)) || "").trim(),
      applicable: discount ? discount.applicable !== false : false
    }));
  }

  function getCampaignDebugOutcome(options) {
    const {
      campaign,
      now,
      qualifies,
      currentCodes,
      resultingCodes,
      attemptedCodeKeys,
      resultingCart
    } = options;

    if (!campaign.autoApply) return "BLOCKED: auto_apply is false";
    if (now < campaign.startsAt) return "WAITING: campaign has not started";
    if (now > campaign.endsAt) return "BLOCKED: campaign has ended";

    if (
      campaign.campaignType === "product_specific" &&
      !campaign.qualifyingProductIds.length
    ) {
      return "BLOCKED: qualifying_products reached JavaScript as an empty list";
    }

    if (!qualifies) {
      return campaign.campaignType === "product_specific"
        ? "NO MATCH: cart product IDs do not match qualifying product IDs"
        : "NO MATCH: cart contains no eligible, non-excluded merchandise";
    }

    if (codeListHas(resultingCodes, campaign.code)) return "SUCCESS: code is applicable";

    const rawCodeStatus = getRawDiscountCodeStatus(resultingCart).find((discount) => {
      return normalizeCode(discount.code) === normalizeCode(campaign.code);
    });

    if (rawCodeStatus && rawCodeStatus.applicable === false) {
      return "REJECTED: Shopify returned applicable: false";
    }

    if (attemptedCodeKeys.has(normalizeCode(campaign.code))) {
      return "REJECTED: code was attempted but Shopify did not return it as applicable";
    }

    if (codeListHas(currentCodes, campaign.code)) {
      return "SUCCESS: code was already applied before this sync";
    }

    return "PAUSED: qualified code is in the 60-second rejection cooldown";
  }

  function buildDebugReport(options = {}) {
    const configuration = options.configuration || {
      campaigns: [],
      appliedDiscountCodes: [],
      isPresent: false,
      rawCampaignCount: 0,
      invalidCampaigns: [],
      errors: []
    };
    const cart = options.cart || null;
    const resultingCart = options.resultingCart || cart;
    const currentCodes = options.currentCodes || [];
    const targetCodes = options.targetCodes || [];
    const desiredCodes = options.desiredCodes || [];
    const resultingCodes = options.resultingCodes || currentCodes;
    const appliedCampaignCodes = options.appliedCampaignCodes || [];
    const renderedRowCodes = options.renderedRowCodes || getRenderedRowCodes();
    const attemptedCampaigns = options.attemptedCampaigns || [];
    const attemptedCodeKeys = new Set(
      attemptedCampaigns.map((campaign) => normalizeCode(campaign.code))
    );
    const now = Date.now();
    const cartItems = cart && Array.isArray(cart.items) ? cart.items : [];
    const merchandiseItems = cart ? getTopLevelMerchandiseItems(cart) : [];
    const campaignReports = configuration.campaigns.map((campaign) => {
      const active = campaignIsActive(campaign, now);
      const qualifies = campaignQualifies(campaign, merchandiseItems);
      const cartProductIds = merchandiseItems.map((item) => {
        return normalizeProductId(item.product_id);
      });
      const qualifyingIdSet = new Set(campaign.qualifyingProductIds);

      return {
        code: campaign.code,
        campaignType: campaign.campaignType,
        autoApply: campaign.autoApply,
        startsAt: formatDebugDate(campaign.startsAt),
        endsAt: formatDebugDate(campaign.endsAt),
        activeNow: active,
        qualifiesNow: active && qualifies,
        qualifyingProductIds: campaign.qualifyingProductIds,
        excludedProductIds: campaign.excludedProductIds,
        matchingCartProductIds:
          campaign.campaignType === "product_specific"
            ? cartProductIds.filter((productId) => qualifyingIdSet.has(productId))
            : [],
        outcome: getCampaignDebugOutcome({
          campaign,
          now,
          qualifies: active && qualifies,
          currentCodes,
          resultingCodes,
          attemptedCodeKeys,
          resultingCart
        })
      };
    });

    let status = "warning";
    let conclusion = "Campaign configuration was found; review the campaign results below.";

    if (options.error) {
      status = "error";
      conclusion = `JavaScript error: ${options.error}`;
    } else if (!configuration.isPresent) {
      status = "error";
      conclusion =
        "The configuration element is missing. Confirm the snippet is rendered with mode: 'config'.";
    } else if (!configuration.campaigns.length) {
      status = "error";
      conclusion =
        "The configuration element exists, but Liquid supplied no valid campaigns.";
    } else if (campaignReports.some((campaign) => campaign.outcome.startsWith("SUCCESS"))) {
      status = "success";
      conclusion = "At least one qualifying campaign code is applied successfully.";
    } else if (!campaignReports.some((campaign) => campaign.activeNow)) {
      conclusion = "No configured campaign is active at the current time.";
    } else if (!campaignReports.some((campaign) => campaign.qualifiesNow)) {
      conclusion =
        "An active campaign was found, but the current cart does not qualify. Compare the product IDs below.";
    } else if (attemptedCampaigns.length) {
      status = "error";
      conclusion =
        "The cart qualified and the code was attempted, but Shopify did not confirm it as applicable.";
    } else {
      conclusion =
        "The cart qualifies, but the code is currently paused by the rejection cooldown. Use Retry now.";
    }

    return {
      checkedAt: new Date(now).toISOString(),
      status,
      conclusion,
      configuration: {
        elementCount: document.querySelectorAll(CONFIG_SELECTOR).length,
        rawCampaignCount: configuration.rawCampaignCount || 0,
        validCampaignCount: configuration.campaigns.length,
        invalidCampaigns: configuration.invalidCampaigns || [],
        parseErrors: configuration.errors || [],
        appliedDiscountCodesFromLiquid: configuration.appliedDiscountCodes || []
      },
      cart: cart
        ? {
            itemCount: Number(cart.item_count || 0),
            items: cartItems.map((item) => ({
              title: String(item.product_title || item.title || ""),
              productId: normalizeProductId(item.product_id),
              variantId: normalizeProductId(item.variant_id),
              quantity: Number(item.quantity || 0),
              eligibleTopLevelMerchandise: isTopLevelMerchandiseItem(item),
              exclusionReason: getItemExclusionReason(item) || null
            })),
            eligibleCartProductIds: merchandiseItems.map((item) => {
              return normalizeProductId(item.product_id);
            }),
            discountCodesBefore: getRawDiscountCodeStatus(cart),
            discountCodesAfter: getRawDiscountCodeStatus(resultingCart)
          }
        : null,
      campaigns: campaignReports,
      sync: {
        currentApplicableCodes: currentCodes,
        targetCodes,
        requestedCodes: desiredCodes,
        attemptedCampaignCodes: attemptedCampaigns.map((campaign) => campaign.code),
        resultingApplicableCodes: resultingCodes,
        appliedCampaignCodes,
        renderedGiftRowCodes: renderedRowCodes,
        discountStateChanged: options.discountStateChanged === true
      }
    };
  }

  function ensureDebugPanel() {
    if (!debugEnabled || !document.body) return null;

    if (!document.getElementById(DEBUG_STYLE_ID)) {
      const style = document.createElement("style");
      style.id = DEBUG_STYLE_ID;
      style.textContent = `
        #${DEBUG_PANEL_ID} {
          position: fixed;
          right: 16px;
          bottom: 16px;
          z-index: 2147483647;
          width: min(620px, calc(100vw - 32px));
          max-height: min(760px, calc(100vh - 32px));
          overflow: auto;
          border: 1px solid rgba(255, 255, 255, 0.18);
          border-radius: 12px;
          color: #f5f7fa;
          background: #101318;
          box-shadow: 0 18px 60px rgba(0, 0, 0, 0.42);
          font: 12px/1.5 ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        }
        #${DEBUG_PANEL_ID} * { box-sizing: border-box; }
        #${DEBUG_PANEL_ID} header {
          position: sticky;
          top: 0;
          z-index: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 12px 14px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.12);
          background: #171b22;
        }
        #${DEBUG_PANEL_ID} strong { font-size: 12px; letter-spacing: 0.04em; }
        #${DEBUG_PANEL_ID} .lgnd-debug__actions { display: flex; gap: 6px; }
        #${DEBUG_PANEL_ID} button {
          padding: 6px 9px;
          border: 1px solid rgba(255, 255, 255, 0.22);
          border-radius: 6px;
          color: inherit;
          background: #252b35;
          font: inherit;
          cursor: pointer;
        }
        #${DEBUG_PANEL_ID} .lgnd-debug__summary {
          margin: 0;
          padding: 12px 14px;
          border-left: 4px solid #f4b740;
          background: rgba(244, 183, 64, 0.1);
          white-space: normal;
        }
        #${DEBUG_PANEL_ID}[data-status="success"] .lgnd-debug__summary {
          border-color: #35c46a;
          background: rgba(53, 196, 106, 0.1);
        }
        #${DEBUG_PANEL_ID}[data-status="error"] .lgnd-debug__summary {
          border-color: #ff5b65;
          background: rgba(255, 91, 101, 0.1);
        }
        #${DEBUG_PANEL_ID} details { padding: 10px 14px 14px; }
        #${DEBUG_PANEL_ID} summary { cursor: pointer; font-weight: 700; }
        #${DEBUG_PANEL_ID} pre {
          margin: 10px 0 0;
          padding: 12px;
          overflow: auto;
          border-radius: 8px;
          color: #dce6f2;
          background: #090b0f;
          white-space: pre-wrap;
          overflow-wrap: anywhere;
        }
        #${DEBUG_PANEL_ID} .lgnd-debug__time {
          display: block;
          padding: 0 14px 10px;
          color: #9ca8b7;
        }
      `;
      document.head.appendChild(style);
    }

    let panel = document.getElementById(DEBUG_PANEL_ID);
    if (panel) return panel;

    panel = document.createElement("section");
    panel.id = DEBUG_PANEL_ID;
    panel.setAttribute("aria-label", "Bonus cart gift debug panel");
    panel.innerHTML = `
      <header>
        <strong>BONUS CART GIFT DEBUG</strong>
        <span class="lgnd-debug__actions">
          <button type="button" data-lgnd-debug-retry>Retry now</button>
          <button type="button" data-lgnd-debug-copy>Copy report</button>
        </span>
      </header>
      <p class="lgnd-debug__summary" data-lgnd-debug-summary>Loading...</p>
      <small class="lgnd-debug__time" data-lgnd-debug-time></small>
      <details open>
        <summary>Full diagnostic report</summary>
        <pre data-lgnd-debug-output></pre>
      </details>
    `;

    panel.querySelector("[data-lgnd-debug-retry]").addEventListener("click", () => {
      writeStorage(window.sessionStorage, FAILURE_KEY, "");
      state.lastRefreshSignature = "";
      state.lastRefreshAt = 0;
      scheduleSync(0);
    });

    panel.querySelector("[data-lgnd-debug-copy]").addEventListener("click", async (event) => {
      const button = event.currentTarget;
      const report = JSON.stringify(state.debugReport || {}, null, 2);

      try {
        await window.navigator.clipboard.writeText(report);
        button.textContent = "Copied";
      } catch (error) {
        button.textContent = "Copy failed";
      }

      window.setTimeout(() => {
        button.textContent = "Copy report";
      }, 1500);
    });

    document.body.appendChild(panel);
    return panel;
  }

  function renderDebugReport(report) {
    state.debugReport = report;
    if (!debugEnabled) return;

    const panel = ensureDebugPanel();
    if (!panel) return;

    panel.dataset.status = report.status || "warning";
    panel.querySelector("[data-lgnd-debug-summary]").textContent = report.conclusion;
    panel.querySelector("[data-lgnd-debug-time]").textContent =
      `Last checked: ${report.checkedAt}`;
    panel.querySelector("[data-lgnd-debug-output]").textContent =
      JSON.stringify(report, null, 2);

    console.log("[Bonus Cart Gift Debug]", report);
  }

  function publishDebugReport(options) {
    if (!debugEnabled) return;
    renderDebugReport(buildDebugReport(options));
  }

  function getRequestUrl(request) {
    if (typeof request === "string") return request;
    if (request && typeof request.url === "string") return request.url;
    return "";
  }

  function wait(milliseconds) {
    return new Promise((resolve) => {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function readStorage(storage, key) {
    try {
      return storage.getItem(key) || "";
    } catch (error) {
      return "";
    }
  }

  function writeStorage(storage, key, value) {
    try {
      if (value) {
        storage.setItem(key, value);
      } else {
        storage.removeItem(key);
      }
    } catch (error) {
      // Storage can be unavailable in private browsing. Cart syncing continues.
    }
  }

  function getStoredAutomaticCodes(cart) {
    const storedValue = readStorage(window.localStorage, STORED_CODES_KEY);
    if (!storedValue) return [];

    try {
      const storedState = JSON.parse(storedValue);

      if (
        storedState &&
        storedState.cartToken &&
        cart &&
        cart.token &&
        storedState.cartToken !== cart.token
      ) {
        return [];
      }

      if (storedState && Array.isArray(storedState.codes)) {
        return uniqueValues(storedState.codes, normalizeCode);
      }

      // Migrate the singular object format used by V1.
      if (storedState && storedState.code) {
        return uniqueValues([storedState.code], normalizeCode);
      }
    } catch (error) {
      // Migrate the plain-string format used by the first release.
      return uniqueValues([storedValue], normalizeCode);
    }

    return [];
  }

  function setStoredAutomaticCodes(codes, cart) {
    const storedCodes = uniqueValues(codes, normalizeCode);

    if (!storedCodes.length) {
      writeStorage(window.localStorage, STORED_CODES_KEY, "");
      return;
    }

    const storedState = { codes: storedCodes };
    if (cart && cart.token) storedState.cartToken = cart.token;

    writeStorage(
      window.localStorage,
      STORED_CODES_KEY,
      JSON.stringify(storedState)
    );
  }

  function parseShopifyDate(value) {
    let dateValue = String(value || "").trim();
    if (!dateValue) return null;

    const hasTimeZone = /(?:z|[+-]\d{2}:?\d{2})$/i.test(dateValue);
    const isIsoDateTime = /^\d{4}-\d{2}-\d{2}t\d{2}:\d{2}/i.test(dateValue);

    if (isIsoDateTime && !hasTimeZone) dateValue += "Z";

    const timestamp = Date.parse(dateValue);
    return Number.isFinite(timestamp) ? timestamp : null;
  }

  function readConfiguration() {
    const campaigns = [];
    const appliedDiscountCodes = [];
    const campaignKeys = new Set();
    const appliedCodeKeys = new Set();
    const invalidCampaigns = [];
    const errors = [];
    let rawCampaignCount = 0;
    const configurationElements = document.querySelectorAll(CONFIG_SELECTOR);

    configurationElements.forEach((element) => {
      try {
        const configuration = JSON.parse(element.textContent || "{}");

        if (Array.isArray(configuration.campaigns)) {
          rawCampaignCount += configuration.campaigns.length;

          configuration.campaigns.forEach((rawCampaign) => {
            const code = String(rawCampaign && rawCampaign.code ? rawCampaign.code : "").trim();
            const startsAt = parseShopifyDate(rawCampaign && rawCampaign.startsAt);
            const endsAt = parseShopifyDate(rawCampaign && rawCampaign.endsAt);
            const campaignType = normalizeCampaignType(
              rawCampaign && rawCampaign.campaignType
            );
            const qualifyingProductIds = uniqueValues(
              Array.isArray(rawCampaign && rawCampaign.qualifyingProductIds)
                ? rawCampaign.qualifyingProductIds
                : [],
              normalizeProductId
            ).map(normalizeProductId);
            const excludedProductIds = uniqueValues(
              Array.isArray(rawCampaign && rawCampaign.excludedProductIds)
                ? rawCampaign.excludedProductIds
                : [],
              normalizeProductId
            ).map(normalizeProductId);
            const campaignKey = [
              normalizeCode(code),
              startsAt,
              endsAt,
              campaignType,
              [...qualifyingProductIds].sort().join(","),
              [...excludedProductIds].sort().join(",")
            ].join("|");
            const validationIssues = [];

            if (!code) validationIssues.push("missing discount code");
            if (startsAt === null) validationIssues.push("invalid starts_at");
            if (endsAt === null) validationIssues.push("invalid ends_at");
            if (startsAt !== null && endsAt !== null && endsAt < startsAt) {
              validationIssues.push("ends_at is before starts_at");
            }
            if (!campaignType) validationIssues.push("unrecognized campaign_type");
            if (campaignKeys.has(campaignKey)) validationIssues.push("duplicate campaign");

            if (validationIssues.length) {
              invalidCampaigns.push({
                code: code || null,
                campaignType: String(
                  (rawCampaign && rawCampaign.campaignType) || ""
                ).trim() || null,
                startsAt: (rawCampaign && rawCampaign.startsAt) || null,
                endsAt: (rawCampaign && rawCampaign.endsAt) || null,
                qualifyingProductIds,
                issues: validationIssues
              });
              return;
            }

            campaignKeys.add(campaignKey);
            campaigns.push({
              code,
              autoApply: rawCampaign.autoApply === true,
              startsAt,
              endsAt,
              campaignType,
              qualifyingProductIds,
              excludedProductIds
            });
          });
        }

        if (Array.isArray(configuration.appliedDiscountCodes)) {
          configuration.appliedDiscountCodes.forEach((code) => {
            const normalizedCode = normalizeCode(code);
            if (!normalizedCode || appliedCodeKeys.has(normalizedCode)) return;

            appliedCodeKeys.add(normalizedCode);
            appliedDiscountCodes.push(String(code).trim());
          });
        }
      } catch (error) {
        errors.push(error && error.message ? error.message : "Invalid JSON");
        console.warn("[Bonus Cart Gift] Invalid Liquid configuration.");
      }
    });

    return {
      campaigns,
      appliedDiscountCodes,
      isPresent: configurationElements.length > 0,
      rawCampaignCount,
      invalidCampaigns,
      errors
    };
  }

  function scheduleDateBoundary(campaigns) {
    window.clearTimeout(state.boundaryTimer);

    const now = Date.now();
    const futureBoundaries = [];

    campaigns.forEach((campaign) => {
      if (!campaign.autoApply) return;
      if (campaign.startsAt > now) futureBoundaries.push(campaign.startsAt);
      if (campaign.endsAt >= now) futureBoundaries.push(campaign.endsAt + 1000);
    });

    if (!futureBoundaries.length) return;

    const nextBoundary = Math.min(...futureBoundaries);
    const maximumTimeout = 2147483000;
    const delay = Math.min(Math.max(nextBoundary - now, 250), maximumTimeout);

    state.boundaryTimer = window.setTimeout(() => scheduleSync(0), delay);
  }

  async function getCart() {
    const response = await originalFetch(`${cartBaseRoute}.js`, {
      method: "GET",
      headers: { Accept: "application/json" }
    });

    if (!response.ok) throw new Error("Unable to retrieve the cart.");
    return response.json();
  }

  function isMarketingFreeGift(item) {
    const properties = item && item.properties ? item.properties : {};
    return String(properties._free_gift || "").toLowerCase() === "true";
  }

  function isRouteProtection(item) {
    const title = String(
      (item && (item.product_title || item.title)) || ""
    ).toLowerCase();

    return title.includes("shipping protection by route");
  }

  function isTopLevelMerchandiseItem(item) {
    return Boolean(
      item &&
      Number(item.quantity || 0) > 0 &&
      !item.parent_relationship &&
      !item.parent_id &&
      !isMarketingFreeGift(item) &&
      !isRouteProtection(item) &&
      normalizeProductId(item.product_id)
    );
  }

  function getTopLevelMerchandiseItems(cart) {
    if (!Array.isArray(cart.items)) return [];
    return cart.items.filter(isTopLevelMerchandiseItem);
  }

  function campaignIsActive(campaign, now = Date.now()) {
    return Boolean(
      campaign &&
      campaign.autoApply &&
      campaign.startsAt <= now &&
      now <= campaign.endsAt
    );
  }

  function campaignQualifies(campaign, merchandiseItems) {
    if (campaign.campaignType === "product_specific") {
      if (!campaign.qualifyingProductIds.length) return false;
      const qualifyingIds = new Set(campaign.qualifyingProductIds);

      return merchandiseItems.some((item) => {
        return qualifyingIds.has(normalizeProductId(item.product_id));
      });
    }

    if (campaign.campaignType === "store_wide") {
      const excludedIds = new Set(campaign.excludedProductIds);

      return merchandiseItems.some((item) => {
        return !excludedIds.has(normalizeProductId(item.product_id));
      });
    }

    return false;
  }

  function getQualifiedCampaigns(campaigns, cart, now = Date.now()) {
    const merchandiseItems = getTopLevelMerchandiseItems(cart);
    const qualifiedByCode = new Map();

    campaigns.forEach((campaign) => {
      if (
        !campaignIsActive(campaign, now) ||
        !campaignQualifies(campaign, merchandiseItems)
      ) {
        return;
      }

      const codeKey = normalizeCode(campaign.code);
      if (!qualifiedByCode.has(codeKey)) qualifiedByCode.set(codeKey, campaign);
    });

    return Array.from(qualifiedByCode.values());
  }

  function addCode(codeMap, code) {
    const displayCode = String(code || "").trim();
    const normalizedCode = normalizeCode(displayCode);
    if (!normalizedCode || codeMap.has(normalizedCode)) return;

    codeMap.set(normalizedCode, displayCode);
  }

  function addDiscountApplication(codeMap, application) {
    if (!application) return;

    const applicationType = String(application.type || "").toLowerCase();
    if (applicationType !== "discount_code") return;

    addCode(codeMap, application.code || application.title);
  }

  function collectCartApplicationCodes(cart, codeMap) {
    [cart.discount_applications, cart.cart_level_discount_applications]
      .filter(Array.isArray)
      .forEach((applications) => {
        applications.forEach((application) => {
          addDiscountApplication(codeMap, application);
        });
      });

    if (!Array.isArray(cart.items)) return;

    cart.items.forEach((item) => {
      const allocations = Array.isArray(item.line_level_discount_allocations)
        ? item.line_level_discount_allocations
        : item.discount_allocations;

      if (!Array.isArray(allocations)) return;

      allocations.forEach((allocation) => {
        addDiscountApplication(codeMap, allocation.discount_application);
      });
    });
  }

  function getAppliedCodes(cart, fallbackCodes = []) {
    const codeMap = new Map();
    const hasExplicitDiscountCodes = Array.isArray(cart.discount_codes);

    if (hasExplicitDiscountCodes) {
      cart.discount_codes.forEach((discount) => {
        if (!discount || discount.applicable === false) return;
        addCode(codeMap, discount.code || discount.title);
      });
    }

    collectCartApplicationCodes(cart, codeMap);

    if (!hasExplicitDiscountCodes && codeMap.size === 0) {
      fallbackCodes.forEach((code) => addCode(codeMap, code));
    }

    return Array.from(codeMap.values());
  }

  function codeListHas(codes, targetCode) {
    const target = normalizeCode(targetCode);
    return Boolean(target && codes.some((code) => normalizeCode(code) === target));
  }

  function withoutCodes(codes, codesToRemove) {
    const removalKeys = new Set(codesToRemove.map(normalizeCode).filter(Boolean));
    return codes.filter((code) => !removalKeys.has(normalizeCode(code)));
  }

  function withCodes(codes, codesToAdd) {
    const codeMap = new Map();
    codes.forEach((code) => addCode(codeMap, code));
    codesToAdd.forEach((code) => addCode(codeMap, code));
    return Array.from(codeMap.values());
  }

  function normalizedCodeSignature(codes) {
    return Array.from(new Set(codes.map(normalizeCode).filter(Boolean)))
      .sort()
      .join("|");
  }

  function codeSetsMatch(leftCodes, rightCodes) {
    return normalizedCodeSignature(leftCodes) === normalizedCodeSignature(rightCodes);
  }

  async function updateDiscountCodes(codes) {
    const response = await originalFetch(`${cartBaseRoute}/update.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ discount: codes.join(",") })
    });

    let cart = null;

    try {
      cart = await response.json();
    } catch (error) {
      // The HTTP status below still provides a useful failure message.
    }

    if (!response.ok || !cart) {
      throw new Error("Shopify did not accept the discount update.");
    }

    return cart;
  }

  function getCartSignature(cart) {
    if (!Array.isArray(cart.items) || !cart.items.length) return "empty";

    return cart.items
      .map((item) => {
        return [item.key || item.variant_id, item.product_id, item.quantity].join(":");
      })
      .sort()
      .join("|");
  }

  function getFailureSignature(campaign, cart, targetCodes, currentCodes) {
    return [
      normalizeCode(campaign.code),
      getCartSignature(cart),
      normalizedCodeSignature(targetCodes),
      normalizedCodeSignature(currentCodes)
    ].join("::");
  }

  function readFailures() {
    const serializedFailures = readStorage(window.sessionStorage, FAILURE_KEY);
    if (!serializedFailures) return {};

    try {
      const failures = JSON.parse(serializedFailures);
      return failures && typeof failures === "object" ? failures : {};
    } catch (error) {
      return {};
    }
  }

  function writeFailures(failures) {
    const activeFailures = {};
    const now = Date.now();

    Object.keys(failures).forEach((codeKey) => {
      const failure = failures[codeKey];
      if (failure && failure.signature && Number(failure.until) > now) {
        activeFailures[codeKey] = failure;
      }
    });

    writeStorage(
      window.sessionStorage,
      FAILURE_KEY,
      Object.keys(activeFailures).length ? JSON.stringify(activeFailures) : ""
    );
  }

  function failureIsCoolingDown(code, signature) {
    const failures = readFailures();
    const failure = failures[normalizeCode(code)];

    return Boolean(
      failure &&
      failure.signature === signature &&
      Number(failure.until) > Date.now()
    );
  }

  function scheduleFailureRetry() {
    window.clearTimeout(state.failureTimer);

    const now = Date.now();
    const retryTimes = Object.values(readFailures())
      .filter((failure) => {
        return (
          failure &&
          Number(failure.attempts || 1) === 1 &&
          Number(failure.until) > now
        );
      })
      .map((failure) => Number(failure.until));

    if (!retryTimes.length) return;

    const retryAt = Math.min(...retryTimes);
    state.failureTimer = window.setTimeout(() => {
      state.failureTimer = 0;
      scheduleSync(0);
    }, Math.max(retryAt - now + 50, 50));
  }

  function storeFailure(code, signature) {
    const failures = readFailures();
    const existingFailure = failures[normalizeCode(code)];
    const attempts =
      existingFailure && existingFailure.signature === signature
        ? Number(existingFailure.attempts || 1) + 1
        : 1;

    failures[normalizeCode(code)] = {
      signature,
      attempts,
      until: Date.now() + FAILURE_COOLDOWN_MS
    };
    writeFailures(failures);
    scheduleFailureRetry();
  }

  function clearFailure(code) {
    const failures = readFailures();
    delete failures[normalizeCode(code)];
    writeFailures(failures);
    scheduleFailureRetry();
  }

  function getRenderedRowCodes() {
    const rowCodes = [];

    document.querySelectorAll(ROW_SELECTOR).forEach((row) => {
      const code = row.dataset ? row.dataset.lgndBonusCartGiftCode : "";
      if (code) rowCodes.push(code);
    });

    return uniqueValues(rowCodes, normalizeCode);
  }

  function refreshCartDisplay(signature) {
    const now = Date.now();
    let previousRefresh = null;

    try {
      previousRefresh = JSON.parse(readStorage(window.sessionStorage, REFRESH_KEY));
    } catch (error) {
      previousRefresh = null;
    }

    if (
      (state.lastRefreshSignature === signature && now - state.lastRefreshAt < 5000) ||
      (previousRefresh &&
        previousRefresh.signature === signature &&
        now - Number(previousRefresh.at) < 10000)
    ) {
      return;
    }

    state.lastRefreshSignature = signature;
    state.lastRefreshAt = now;
    writeStorage(
      window.sessionStorage,
      REFRESH_KEY,
      JSON.stringify({ signature, at: now })
    );

    document.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: { source: "bonus-cart-gift" }
      })
    );

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: { source: "bonus-cart-gift" }
      })
    );

    if (
      window.location.pathname.replace(/\/$/, "") ===
      `${routeRoot.replace(/\/$/, "")}cart`
    ) {
      window.location.reload();
    }
  }

  function cleanPresentation() {
    document.querySelectorAll(DISCOUNT_BADGE_SELECTOR).forEach((badge) => {
      if (badge.dataset.lgndHiddenByBonusGift === "true") {
        badge.hidden = false;
        badge.removeAttribute("aria-hidden");
        delete badge.dataset.lgndHiddenByBonusGift;
      }
    });
  }

  function schedulePresentationCleanup() {
    window.clearTimeout(state.presentationTimer);
    state.presentationTimer = window.setTimeout(cleanPresentation, 50);
  }

  async function syncBonusCartGifts() {
    const configuration = readConfiguration();
    scheduleDateBoundary(configuration.campaigns);
    cleanPresentation();

    if (!configuration.isPresent) {
      publishDebugReport({ configuration });
      return;
    }

    const debugContext = { configuration };

    try {
      const cart = await getCart();
      debugContext.cart = cart;
      const currentCodes = getAppliedCodes(
        cart,
        configuration.appliedDiscountCodes
      );
      debugContext.currentCodes = currentCodes;
      const qualifiedCampaigns = getQualifiedCampaigns(
        configuration.campaigns,
        cart
      );
      const qualifiedCodes = qualifiedCampaigns.map((campaign) => campaign.code);
      const qualifiedCodeKeys = new Set(qualifiedCodes.map(normalizeCode));
      const storedAutomaticCodes = getStoredAutomaticCodes(cart);
      const configuredAutomaticCodes = configuration.campaigns
        .filter((campaign) => campaign.autoApply)
        .map((campaign) => campaign.code);
      const managedCodes = uniqueValues(
        [...storedAutomaticCodes, ...configuredAutomaticCodes],
        normalizeCode
      );
      const unqualifiedManagedCodes = managedCodes.filter((code) => {
        return !qualifiedCodeKeys.has(normalizeCode(code));
      });
      const baseDesiredCodes = withoutCodes(
        currentCodes,
        unqualifiedManagedCodes
      );
      const targetCodes = withCodes(baseDesiredCodes, qualifiedCodes);
      let desiredCodes = [...baseDesiredCodes];
      const attemptedCampaigns = [];

      debugContext.targetCodes = targetCodes;

      qualifiedCampaigns.forEach((campaign) => {
        if (codeListHas(currentCodes, campaign.code)) {
          desiredCodes = withCodes(desiredCodes, [campaign.code]);
          return;
        }

        const failureSignature = getFailureSignature(
          campaign,
          cart,
          targetCodes,
          currentCodes
        );

        if (failureIsCoolingDown(campaign.code, failureSignature)) return;

        desiredCodes = withCodes(desiredCodes, [campaign.code]);
        attemptedCampaigns.push(campaign);
      });

      debugContext.desiredCodes = desiredCodes;
      debugContext.attemptedCampaigns = attemptedCampaigns;

      let resultingCart = cart;
      let resultingCodes = currentCodes;

      if (!codeSetsMatch(currentCodes, desiredCodes)) {
        resultingCart = await updateDiscountCodes(desiredCodes);
        resultingCodes = getAppliedCodes(resultingCart);

        const attemptedCodeWasMissing = attemptedCampaigns.some((campaign) => {
          return !codeListHas(resultingCodes, campaign.code);
        });

        // A second read prevents a transient cart/update response or a
        // simultaneous cart app mutation from being treated as a final reject.
        if (attemptedCodeWasMissing) {
          await wait(REJECTION_VERIFICATION_DELAY_MS);
          resultingCart = await getCart();
          resultingCodes = getAppliedCodes(resultingCart);
        }
      }

      const discountStateChanged = !codeSetsMatch(currentCodes, resultingCodes);

      qualifiedCampaigns.forEach((campaign) => {
        if (codeListHas(resultingCodes, campaign.code)) {
          clearFailure(campaign.code);
          return;
        }

        if (
          attemptedCampaigns.some((attempted) => {
            return normalizeCode(attempted.code) === normalizeCode(campaign.code);
          })
        ) {
          const failureSignature = getFailureSignature(
            campaign,
            resultingCart,
            targetCodes,
            resultingCodes
          );
          storeFailure(campaign.code, failureSignature);
          console.warn(
            `[Bonus Cart Gift] ${campaign.code} was not applicable, so no cart gift was shown.`
          );
        }
      });

      configuration.campaigns.forEach((campaign) => {
        if (!qualifiedCodeKeys.has(normalizeCode(campaign.code))) {
          clearFailure(campaign.code);
        }
      });

      const appliedCampaignCodes = qualifiedCodes.filter((code) => {
        return codeListHas(resultingCodes, code);
      });
      const renderedRowCodes = getRenderedRowCodes();

      setStoredAutomaticCodes(appliedCampaignCodes, resultingCart);

      publishDebugReport({
        ...debugContext,
        resultingCart,
        resultingCodes,
        appliedCampaignCodes,
        renderedRowCodes,
        discountStateChanged
      });

      if (
        discountStateChanged ||
        !codeSetsMatch(renderedRowCodes, appliedCampaignCodes)
      ) {
        refreshCartDisplay(
          [
            "campaigns",
            getCartSignature(resultingCart),
            normalizedCodeSignature(appliedCampaignCodes),
            normalizedCodeSignature(resultingCodes)
          ].join(":")
        );
      }
    } catch (error) {
      console.warn("[Bonus Cart Gift]", error.message);
      publishDebugReport({
        ...debugContext,
        error: error && error.message ? error.message : String(error)
      });
    }
  }

  async function runSyncQueue() {
    window.clearTimeout(state.syncTimer);
    state.syncTimer = 0;

    if (state.syncing) {
      state.syncQueued = true;
      return;
    }

    state.syncing = true;

    try {
      do {
        state.syncQueued = false;
        const startingRevision = state.mutationRevision;

        await syncBonusCartGifts();

        if (startingRevision !== state.mutationRevision) {
          state.syncQueued = true;
        }
      } while (state.syncQueued);
    } catch (error) {
      console.warn(
        "[Bonus Cart Gift] Sync queue failed:",
        error && error.message ? error.message : String(error)
      );
    } finally {
      state.syncing = false;
      schedulePresentationCleanup();

      // Covers a mutation queued at the boundary between the final pass and
      // releasing the lock.
      if (state.syncQueued) scheduleSync(0);
    }
  }

  function scheduleSync(delay = 200) {
    state.syncQueued = true;

    if (state.syncing) return;

    window.clearTimeout(state.syncTimer);
    state.syncTimer = window.setTimeout(runSyncQueue, delay);
  }

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const requestUrl = getRequestUrl(args[0]);

    if (response.ok && CART_MUTATION_PATTERN.test(requestUrl)) {
      state.mutationRevision += 1;
      scheduleSync();
    }

    return response;
  };

  function eventCameFromBonusGift(event) {
    return Boolean(
      event &&
      event.detail &&
      event.detail.source === "bonus-cart-gift"
    );
  }

  document.addEventListener("cart:refresh", (event) => {
    schedulePresentationCleanup();
    if (!eventCameFromBonusGift(event)) scheduleSync(100);
  });

  document.addEventListener("cart:updated", (event) => {
    if (!eventCameFromBonusGift(event)) scheduleSync();
  });

  const observer = new MutationObserver(schedulePresentationCleanup);

  function initialize() {
    observer.observe(document.documentElement, { childList: true, subtree: true });
    cleanPresentation();
    scheduleFailureRetry();
    scheduleSync(0);
  }

  window.LGNDBonusCartGift = {
    refresh: () => scheduleSync(0),
    debug: () => {
      debugEnabled = true;
      scheduleSync(0);
      return state.debugReport;
    },
    getDebugReport: () => state.debugReport
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
